import Button from "shared/controls/button";

const ActionBarButton = Button.extend({
  beforeRender() {
    ActionBarButton.__super__.beforeRender.apply(this, arguments);
    this.$el.addClass("filter-area-item");
  }
});

export default ActionBarButton;
